import { render } from "./Dialog.vue?vue&type=template&id=3283c044&scoped=true&ts=true"
import script from "./dialogHelper.ts?vue&type=script&lang=ts"
export * from "./dialogHelper.ts?vue&type=script&lang=ts"

import "./Dialog.vue?vue&type=style&index=0&id=3283c044&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3283c044"]])

export default __exports__